<nav role="banner" class="navbar bg-primary d-print-none p-0">
  <div class="container-fluid">
    <div class="navbar-collapse row row-cols-1 row-cols-md-3">
      <div class="col">
        <button *ngIf="loggedIn" class="navbar-toggler me-3 mb-2" type="button" data-bs-toggle="collapse" data-bs-target="#left-nav" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon" aria-hidden="true"></span>
        </button>
        <a routerLink="/" class="navbar-brand text-wrap text-white atf-logo-link fs-4" aria-label="Navigate to the NESS homepage">
          <img src="/assets/images/atf-logo.png" alt="Bureau of Alcohol, Tobacco, Firearms, and Explosives seal" class="bi" aria-hidden="true" />
          NIBIN Enforcement Support System
        </a>
      </div>
      <div class="col navbar-text text-highlight text-lg-center fs-1" id="training-warning">{{ bannerMessages }}</div>
      <div class="col text-lg-end text-white">
        <ness-account></ness-account>
      </div>
    </div>
  </div>
</nav>
